var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0732422 24C0.0732422 10.7452 10.8184 0 24.0732 0C37.3281 0 48.0732 10.7452 48.0732 24C48.0732 37.2548 37.3281 48 24.0732 48C10.8184 48 0.0732422 37.2548 0.0732422 24Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5088_80216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1479 9.98932C32.4675 11.1606 35.2641 13.4713 37.0403 16.5106C38.8164 19.5498 39.4571 23.1205 38.8482 26.5876C38.2394 30.0547 36.4206 33.1936 33.7152 35.4458C31.0098 37.6981 27.5933 38.9178 24.0732 38.888",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0728 13L29.1475 9.98933L32.0728 9",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9987 38.0106C15.6791 36.8394 12.8826 34.5286 11.1064 31.4894C9.3302 28.4502 8.68956 24.8795 9.2984 21.4124C9.90723 17.9452 11.7261 14.8064 14.4314 12.5542C17.1368 10.3019 20.5533 9.08221 24.0734 9.11198",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0732 35L18.9986 38.0107L16.0732 39",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4412 18L21.5399 16H26.5732L28.6719 18H30.7652C31.3713 18.0267 31.9451 18.2804 32.3727 18.7107C32.8003 19.141 33.0504 19.7165 33.0732 20.3227V27.9227C33.0402 28.5033 32.7791 29.0473 32.3468 29.4364C31.9146 29.8254 31.3461 30.028 30.7652 30H17.3812C16.8012 30.0281 16.2336 29.8262 15.8014 29.4383C15.3693 29.0504 15.1077 28.5077 15.0732 27.928V20.328C15.0948 19.7209 15.3443 19.1441 15.772 18.7127C16.1997 18.2812 16.7743 18.0268 17.3812 18H19.4412Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0732 24C21.0732 24.7956 21.3893 25.5587 21.9519 26.1213C22.5145 26.6839 23.2776 27 24.0732 27C24.8689 27 25.632 26.6839 26.1946 26.1213C26.7572 25.5587 27.0732 24.7956 27.0732 24C27.0732 23.2044 26.7572 22.4413 26.1946 21.8787C25.632 21.3161 24.8689 21 24.0732 21C23.2776 21 22.5145 21.3161 21.9519 21.8787C21.3893 22.4413 21.0732 23.2044 21.0732 24V24Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5088_80216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8.07324 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraSwitch);
export default __webpack_public_path__ + "static/media/camera_switch.3ece1b92.svg";
export { ForwardRef as ReactComponent };